import { Navigate } from 'react-router-dom';
import OrganizationList from '../components/DC/OrganizationList';
import OrganizationMerge from '../components/DC/OrganizationMerge';
import OrganizationMergeList from '../components/DC/OrganizationMergeList';
import ExpertOverview from '../components/Expert/overview';
import ExpertLegacyRedirect from '../components/Expert/ExpertLegacyRedirect';
import ExpertEvaluation from '../components/Expert/evaluation';

const dataCenterRoutes = [
    //专家列表（新增/编辑均在 ExpertOverview 抽屉内完成；旧链接重定向到列表并带查询参数）
    { path: 'experts', element: <ExpertOverview /> },
    { path: 'experts/new', element: <Navigate to="/dc/experts?create=1" replace /> },
    { path: 'experts/:id', element: <ExpertLegacyRedirect /> },

    //专家价值
    { path: 'experts-evaluation', element: <ExpertEvaluation /> },

    // 机构库
    { path: 'organization/list', element: <OrganizationList /> },
    { path: 'organization/merge-management', element: <OrganizationMergeList /> },
    { path: 'organization/merge', element: <OrganizationMerge /> },
];

export default dataCenterRoutes;
